export default __webpack_public_path__ + "static/media/seven.86e7d95c.png";